// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nIYV3","type":"styles_type__3nK47","choices":"styles_choices__2XBKk"};